<div class="container">
  <div class="col-md-12">
    <!-- Header -->
    <div class="client-header">
      <div class="client-header-content">
        <!-- Client Info Section -->
        <div class="client-info-section">
          <div class="client-name-row">
            <h2 class="client-name">
              {{ client.companyName || "New Client" }}
            </h2>
            <span class="status-pill" [ngClass]="client.isActive ? 'status-on' : 'status-off'">
              {{ client.isActive ? "Active" : "Inactive" }}
            </span>
          </div>
          <div class="client-basic-info">
            <div class="info-item">
              <strong>Phone:</strong>
              {{ client.phone || "N/A" }}
            </div>
            <div class="info-item">
              <strong>Email:</strong>
              {{ client.email || "N/A" }}
            </div>
            <div class="info-item">
              <i class="fa fa-map-marker"></i><strong>Location:</strong>
              {{ getLocationString() }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="main-content">
      <!-- Tabs -->
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item" [class.active]="selectedTab === 'profile'" *ngIf="canViewProfileTab()">
          <a class="nav-link" (click)="onTabClicked('profile')"> Profile </a>
        </li>
        <li
          class="nav-item"
          [class.active]="selectedTab === 'compliance'"
          *ngIf="canViewComplianceTab()"
        >
          <a class="nav-link" (click)="onTabClicked('compliance')"> Compliance </a>
        </li>
        <li
          class="nav-item"
          [class.active]="selectedTab === 'notes'"
          *ngIf="canViewNotesTab() && !isNewClient"
        >
          <a class="nav-link" (click)="onTabClicked('notes')"> Notes </a>
        </li>
        <li
          class="nav-item"
          [class.active]="selectedTab === 'drivernotes'"
          *ngIf="canViewDriverNotesTab() && !isNewClient"
        >
          <a class="nav-link" (click)="onTabClicked('drivernotes')"> Driver Notes </a>
        </li>
        <li
          class="nav-item"
          [class.active]="selectedTab === 'boards'"
          *ngIf="canViewBoardsTab() && !isNewClient"
        >
          <a class="nav-link" (click)="onTabClicked('boards')"> Boards </a>
        </li>
        <li class="nav-item" [class.active]="selectedTab === 'billto'" *ngIf="canViewBillToTab()">
          <a class="nav-link" (click)="onTabClicked('billto')"> Bill To </a>
        </li>
      </ul>

      <!-- Tab Content -->
      <div class="tab-content white-bg-tabs">
        <!-- Profile Tab -->
        <div *ngIf="selectedTab === 'profile'">
          <app-client-profile
            [client]="client"
            [isEditMode]="isEditMode"
            [canEdit]="canEditProfileTab()"
            [states]="states"
            [phoneMask]="phoneMask"
            [dateInputMask]="dateInputMask"
            [zipMask]="zipMask"
            (hasChanges)="onTabHasChanges($event)"
          ></app-client-profile>
        </div>

        <!-- Compliance Tab -->
        <div *ngIf="selectedTab === 'compliance'">
          <app-client-compliance
            [client]="client"
            [isEditMode]="isEditMode"
            [canEdit]="canEditComplianceTab()"
            (hasChanges)="onTabHasChanges($event)"
          ></app-client-compliance>
        </div>

        <!-- Notes Tab -->
        <div *ngIf="selectedTab === 'notes'">
          <app-client-notes [client]="client" [canEdit]="canEditNotesTab()"></app-client-notes>
        </div>

        <!-- Driver Notes Tab -->
        <div *ngIf="selectedTab === 'drivernotes'">
          <app-client-driver-notes [client]="client"></app-client-driver-notes>
        </div>

        <!-- Boards Tab -->
        <div *ngIf="selectedTab === 'boards'">
          <app-client-boards [client]="client" [canEdit]="canEditBoardsTab()"></app-client-boards>
        </div>

        <!-- Bill To Tab -->
        <div *ngIf="selectedTab === 'billto'">
          <app-client-billto
            #billToComponent
            [client]="client"
            [isEditMode]="isEditMode"
            [states]="states"
            [phoneMask]="phoneMask"
            [dateInputMask]="dateInputMask"
            [zipMask]="zipMask"
            [canViewProfileTab]="canViewBillToProfileTab()"
            [canViewContactsTab]="canViewBillToContactsTab()"
            [canViewBillingTab]="canViewBillToBillingTab()"
            [canEditProfileTab]="canEditBillToProfileTab()"
            [canEditContactsTab]="canEditBillToContactsTab()"
            [canEditBillingTab]="canEditBillToBillingTab()"
            (hasChanges)="onTabHasChanges($event)"
            (newBillTosChange)="onNewBillTosChange($event)"
            (editedBillTosChange)="onEditedBillTosChange($event)"
            (removedBillTosChange)="onRemovedBillTosChange($event)"
          ></app-client-billto>
        </div>
      </div>
    </div>

    <!-- Footer with Action Buttons -->
    <div class="client-footer">
      <div class="footer-left"></div>
      <div class="footer-right">
        <button class="btn btn-secondary" (click)="navigateToList()">
          <i class="fa fa-arrow-left"></i>
          Back to List
        </button>
        <button
          *ngIf="isEditMode"
          class="btn btn-secondary"
          (click)="cancelEdit()"
          [disabled]="isProcessing"
        >
          <i class="fa fa-times"></i>
          Cancel
        </button>
        <button
          *ngIf="!isNewClient && canEditAnyTab()"
          class="btn btn-primary"
          (click)="toggleEditMode()"
          [disabled]="isProcessing"
        >
          <i class="fa" [ngClass]="isEditMode ? 'fa-save' : 'fa-pencil'"></i>
          {{ isEditMode ? "Save Client" : "Edit Client" }}
        </button>
        <button
          *ngIf="isNewClient"
          class="btn btn-primary"
          (click)="saveClient()"
          [disabled]="isProcessing"
        >
          <i class="fa fa-save"></i>
          Create Client
        </button>
      </div>
    </div>
  </div>
</div>
